import { QueryClient } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import {
  getBackofficeCompanyQuery,
  getBackofficeCompanyQueryKey,
} from "modules/backoffice/lib/companies/getBackofficeCompanyQuery"
import { Crumb } from "modules/shared/lib/breadcrumbs"
import { BackofficeGetCompanyResponseDataSchema } from "schema"
import z from "zod"

function getCompanyName(id: string, queryClient: QueryClient) {
  const company = queryClient.getQueryData(getBackofficeCompanyQueryKey({ id })) as z.infer<
    typeof BackofficeGetCompanyResponseDataSchema
  >
  if (company) return company.name

  return queryClient
    .fetchQuery(getBackofficeCompanyQuery({ query: { id } }))
    .then((company) => company.name)
}

export const Route = createFileRoute(
  "/_base/_auth/backoffice/organizations/$id/companies/$companyId",
)({
  loader: async ({ context, route: { fullPath }, params }) => {
    return new Crumb({
      fullPath,
      title: getCompanyName(params.companyId, context.queryClient),
    })
  },
})
